export let BI_ORIGIN;
(function (BI_ORIGIN) {
  BI_ORIGIN["ON_SITE"] = "on_site";
})(BI_ORIGIN || (BI_ORIGIN = {}));
export let BI_VIDEO_TYPE;
(function (BI_VIDEO_TYPE) {
  BI_VIDEO_TYPE["LIVE"] = "live";
  BI_VIDEO_TYPE["SCHEDULED"] = "scheduled";
})(BI_VIDEO_TYPE || (BI_VIDEO_TYPE = {}));
//# sourceMappingURL=bi.js.map